import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

class ToastComponent extends Component {
  constructor(props, context) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className={
          this.props.isSuccessMessage
            ? "Alert-col open"
            : this.props.isErrorMessage
            ? "Alert-col open"
            : this.props.isValidationOccur
            ? "Alert-col open"
            : "Alert-col"
        }
      >
        {this.props.isSuccessMessage && (
          <div className="alert alert-success">{this.props.message}</div>
        )}
        {this.props.isErrorMessage && (
          <div className="alert alert-danger">{this.props.message}</div>
        )}
        {this.props.isValidationOccur && (
          <div className="alert alert-danger">
            {this.context.t(this.props.labelKey)}&nbsp; {this.context.t(this.props.message)}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isSuccessMessage: state.toastComponentReducer.isSuccessMessage,
    isErrorMessage: state.toastComponentReducer.isErrorMessage,
    isDefaultErrorMessage: state.toastComponentReducer.isDefaultErrorMessage,
    isValidationOccur: state.toastComponentReducer.isValidationOccur,
    labelKey: state.toastComponentReducer.labelKey,
    message: state.toastComponentReducer.message,
  };
};

ToastComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ToastComponent);